import { render, staticRenderFns } from "./personDetails.vue?vue&type=template&id=1fd3f58a&scoped=true&"
import script from "./personDetails.vue?vue&type=script&lang=js&"
export * from "./personDetails.vue?vue&type=script&lang=js&"
import style0 from "./personDetails.vue?vue&type=style&index=0&id=1fd3f58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3f58a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VRow,VTextField})
